
module dgUtils {

    export interface IFilterService extends ng.IFilterService {
        //From angular-filter
        (name: 'stringular'): IStringularFilter;
        (name: 'toArray'): IToArrayFilter;
        (name: 'camelToDashes'): IStringTransformFilter;
        (name: 'dashesToCamel'): IStringTransformFilter;

        //Ours
        (name: 'dgLinksByRel'): IDgLinksByRelFIlter;
        (name: 'dgEnabledLinks'): IDgEnabledLinksFilter;
        (name: 'duration'): IDgDurationFilter;
    }

    export interface IStringTransformFilter extends Function {
        (str: string): string;
    }
}